import { lambdaClient } from '../config/http.client';

export const generateSdlcPipeline = async (params) => {
  const response = await lambdaClient.post('/sdlc/generate', params);
  return response.data;
};

export const getSdlcPipelineJob = async (jobId) => {
  const response = await lambdaClient.get(`/agentcore/jobs/${jobId}`, {
    params: { type: 'sdlc_pipeline' },
  });
  return response.data;
};

export const getSdlcPipelineJobs = async (limit = 20) => {
  const response = await lambdaClient.get('/agentcore/jobs', {
    params: { type: 'sdlc_pipeline', limit },
  });
  return response.data;
};

const sdlcPipelineService = {
  generateSdlcPipeline,
  getSdlcPipelineJob,
  getSdlcPipelineJobs,
};

export default sdlcPipelineService;